import { useDispatch } from 'react-redux'

import ItemWithBadgesActions, {
  type ItemWithBadgesActionsProps,
} from '~/components/dashboard/soapV2/collapsibleRail/summary/item-with-badges/ItemWithBadgesActions'
import { useHandleDelete } from '~/components/dashboard/soapV2/collapsibleRail/summary/utils/useHandleDelete'
import { removeOrder } from '~/store/actions/orders'
import type { Order } from '~/types'

export interface TaskOrderActionsProps extends ItemWithBadgesActionsProps {
  onDelete?: () => void
  order: Order
}

const TaskOrderActions = ({
  onDelete: onDeleteProp,
  order,
  ...rest
}: TaskOrderActionsProps) => {
  const dispatch = useDispatch()

  const handleDelete = useHandleDelete(
    order,
    () => dispatch(removeOrder(order)),
    onDeleteProp,
  )

  return <ItemWithBadgesActions onDelete={handleDelete} {...rest} />
}

export default TaskOrderActions
